import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {ZoneTileType25, ZoneTileViewData} from "../../models";
import {MenuService, ParametersService, SubtitlesService, ViewsService, ZonesService} from "../../core";
import {StateService} from "@uirouter/core";
import * as _ from 'lodash';

@Component({
    selector: 'simple-valve',
    templateUrl: './simple-valve.component.html',
    styleUrl: './simple-valve.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleValveComponent {
    @Input() tile!: ZoneTileType25;

    private menu = inject(MenuService);
    private parameters = inject(ParametersService);
    private $state = inject(StateService);
    private subtitlesService = inject(SubtitlesService);
    private viewsService = inject(ViewsService);
    private zonesService = inject(ZonesService);

    protected showParameters = false;

    protected labels = {
        openingPercentage: this.subtitlesService.setSubtitle(1161),
    };

    protected get tileName(): string {
        const tileName = this.zonesService.setTileName(this.tile.params.txtId, 5731);
        const valveNumber = this.tile.params.valveNumber > 0 ? ` ${this.tile.params.valveNumber}` : '';
        return tileName + valveNumber;
    }

    protected get isMobile(): boolean {
        return this.viewsService.isMobileView();
    }

    protected toggleParameters(): void {
        this.showParameters = !this.showParameters;
    }

    protected setTemplate(): void {
        if (this.tile.menuId === 0) {
            this.showParameters = false;
            return;
        }
        if (window.innerWidth > 696) {
            this.goToZonesMenu();
            return;
        }

        const zonesValue: ZoneTileViewData = {
            description: {name: this.tileName, styleIcon: 'valve'},
            tile: this.tile
        };
        this.zonesService.selectedZone = _.cloneDeep(zonesValue);
        this.$state.go('simple_valve_select', {
            selectedModuleHash: this.parameters.selectedModuleHash
        });
    }

    private goToZonesMenu(): void {
        if (!this.tile.submenuElementId) {
            this.setSubmenuElementId();
        }
        this.zonesService.goToMenu(this.tile, this.tile.submenuElementId);
    }

    private setSubmenuElementId(): void {
        this.menu.getElementMenu(this.tile.menuId); // menu element for tile
        this.menu.getMenuChildElement(this.menu.elementMenu) // set menu.submenu
        if (this.menu.submenu[0]) {
            this.tile.submenuElementId = this.menu.submenu[0].id;
        }
    }
}
